import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ListChecks } from 'lucide-react';
import CustomInvoiceBuilder from '../../components/vendor/invoice/CustomInvoiceBuilder';
import { VendorPageHeader, VendorGuideCallout } from '../../components/vendor/guidance';
import { VENDOR_PAGE_GUIDES } from '../../utils/vendorPageGuides';

const VendorInvoiceCreate = () => {
  return (
    <div className="space-y-5">
      <div>
        <Link
          to="/vendor/invoices"
          className="inline-flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to invoices
        </Link>
        <VendorPageHeader
          title="Custom invoice"
          subtitle="Create invoices for platform clients, guest contacts, or one-off work — with any line items."
        />
      </div>
      <VendorGuideCallout
        title={VENDOR_PAGE_GUIDES.invoiceCreate.title}
        steps={VENDOR_PAGE_GUIDES.invoiceCreate.steps}
        icon={ListChecks}
      />
      <CustomInvoiceBuilder />
    </div>
  );
};

export default VendorInvoiceCreate;
